var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowSelected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 8,
    viewBox: "0 0 20 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 8.37868L17.5613 0.43934C18.1192 -0.146447 19.0237 -0.146447 19.5816 0.43934C20.1395 1.02513 20.1395 1.97487 19.5816 2.56066L11.0102 11.5607C10.4523 12.1464 9.54774 12.1464 8.98985 11.5607L0.418419 2.56066C-0.139473 1.97487 -0.139473 1.02513 0.418419 0.439339C0.976311 -0.146447 1.88083 -0.146447 2.43872 0.439339L10 8.37868Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowSelected);
export default __webpack_public_path__ + "static/media/arrow_selected.cc57398c0812e162df6db25bbbfffb28.svg";
export { ForwardRef as ReactComponent };